export enum IdStatusDocumentoRotulo {
    PendenteAnaliseRotulo = 1,
    RotuloAnalisado = 2,
    PendenteResposta = 3,
    PendenteAnaliseResposta = 4,
    PendenteRevisaoInterna = 5,
    Concluido = 6,
    Cancelado = 9,
}
